import React from 'react'
import { useMemo } from 'sb-hooks'

import { Row, Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'


type GroupProps = {
  className?: string
  emoji: string
  title: ReactIntlMessage
  items: Review.LikeTag[]
}

const Group: React.FunctionComponent<GroupProps> = ({ className, emoji, title, items }) => {
  const text = useMemo(() => (
    items
      .map((item) => item.name)
      .join(', ')
  ), [ items ])

  return (
    <div className={className}>
      <Row justify="start">
        <Box mr={8}>
          <Text size="22-32" message={emoji} />
        </Box>
        <Text size="12-16" color="gray-50" semibold uppercase letterSpacing message={title} />
      </Row>
      <Box mt={8}>
        <Text size="16-24">
          {text || '–'}
        </Text>
      </Box>
    </div>
  )
}

export default Group
